import React from 'react'
import './Footer.css'
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const Footer = () => {
  const {i18n, t} = useTranslation();

  useEffect(() => {
    const len = localStorage.getItem("len");
    if (len) {
      i18n.changeLanguage(len);
    }
  }, [])

  return (
    <div className='Footer'>
            <span>{t('footer.description')}</span>
            <a href="https://twitter.com/maschesitou" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24" aria-hidden="true" className="svg-x r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-lrsllp r-vlxjld r-16y2uox r-8kz0gk">
                    <g>
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                    </g>
                </svg>
            </a>
    </div>
  )
}
